import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--copy-document-number"
export default class extends Controller {
  static targets = ["number", "variableSymbol", "title", "preview"]

  static values = {
    isEditMode: Boolean
  }

  connect() {
    this.#updateTitle()
    this.variableSymbolManuallyEdited = false

    if (this.hasVariableSymbolTarget && !this.isEditModeValue) {
      this.#copyNumberToVariableSymbol()
    }
  }

  // The listener lives on the target's lifecycle, not in connect(): the
  // lifecycle-transition stream REPLACES the VS input after a mint (the server
  // derived a VS from the minted number), and a listener bound in connect()
  // died with the old node — the next number edit then overwrote whatever the
  // user had typed into the new one.
  //
  // A VS the user typed but never saved is also carried across the swap. The
  // mint could not see it (issuing is its own form), so the server's derived VS
  // arrives in the new input; the typed one used to survive in the form and
  // win on the next save, and still does.
  variableSymbolTargetConnected(input) {
    if (this.variableSymbolManuallyEdited && this.manualVariableSymbol) {
      input.value = this.manualVariableSymbol
    }

    input.addEventListener("input", () => {
      this.variableSymbolManuallyEdited = true
      this.manualVariableSymbol = input.value
    })
  }

  onNumberChange() {
    this.#updateTitle()
    if (!this.variableSymbolManuallyEdited) {
      this.#copyNumberToVariableSymbol()
    }
  }

  #updateTitle() {
    if (this.hasTitleTarget && this.hasNumberTarget) {
      this.titleTarget.textContent = this.numberTarget.value
    }

    if (this.hasPreviewTarget && this.hasNumberTarget) {
      this.previewTarget.hidden = this.numberTarget.value.trim().length > 0
    }
  }

  #copyNumberToVariableSymbol() {
    if (this.hasNumberTarget && this.hasVariableSymbolTarget) {
      this.variableSymbolTarget.value = this.numberTarget.value.replace(/\D/g, "")
    }
  }
}
